import { z } from 'zod';

export const OnboardingStatusSchema = z.object({
  isDone: z.boolean().optional(),
  isDiscarded: z.boolean().optional(),
});

export type OnboardingStatus = z.infer<typeof OnboardingStatusSchema>;

export enum OnboardingStepId {
  Welcome = 'welcome',
  AITools = 'ai-tools',
  GenerateAvatar = 'generate-avatar',
  AnimateImage = 'animate-image',
  Templates = 'templates',
}

export type OnboardingStatuses = Record<OnboardingStepId, OnboardingStatus>;

export type OnboardingAction = {
  pushPath: (path: string) => void;
};

export type OnboardingStep = {
  id: OnboardingStepId;
  title: string;
  description: string;
  image: string;
  buttonText: string;
  buttonVariant: 'primary' | 'secondary';
  action: (props: OnboardingAction) => void;
  getIsDisabled: (onboardingStatuses?: OnboardingStatuses) => boolean;
};
